import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  userAdminFetchContactsSuccess,
  userAdminShowContactMessage,
  submitNewUserAdminResponse,
  submitEditUserDetailsResponse,
  selectedUserDeleteResposne,
  // toggleUserModal,
  userFailResponse,
  setUserList,
  changeAdminLoader,
  adminBookFailResponse,
  updateUserList,
  failResponseMessage,
  userAdminHideContactLoader,
  userOnHideLoader
} from "../actions";
import {
  USER_ADMIN_FETCH_ALL_CONTACT,
  SUBMIT_NEW_USER_ADMIN,
  SELECTED_USER_DELETE,
} from "../constants/ActionTypes";
import axios from "../services/customer";
import {formatPhone} from '../util/normalizePhone';

function* fetchUserRequest(action) {
  try {
    const fetchedContact = yield axios.get("/users?role._id=5bce0f4b7e768500167699c4");
    let Data = fetchedContact.data;
    Data.forEach(element => {
      element.phonenumber = formatPhone(element.phonenumber);
    })
    // for(let i = 0; i< Data.length; i++) {
    //   Data[0]
    // }
    yield put(userAdminFetchContactsSuccess(Data));
  } catch (error) {
		yield put(userFailResponse(error.response.data.message));
  }
}

function* submitNewUser({ payload }) {
  try {
    const { addUserState, editUserState } = payload;
    if (addUserState) {
      const { formValues, imageFile } = payload;
      const { firstname, lastname, phonenumber, email } = formValues;
			
      const userRequest = {
        firstname,
        lastname,
        phonenumber: phonenumber=='' || phonenumber == null ? "" : '+'+phonenumber.replace(/[^\d]/g, ''),
        email,
        username: email,
        role: "5bce0f4b7e768500167699c4",
      };

      const userResponse = yield axios.post("/users", userRequest);

      // const { address1, address2, city, stateId: state, zipcode, gender, country } = formValues;

      // const { date_of_birth } = payload;
      // const customerRequest = {
      //   date_of_birth,
      //   address1,
      //   address2,
      //   city,
      //   state,
      //   zipcode,
      //   gender,
      //   country,
      //   primary_details: userResponse.data._id,
      // };

      // const customerResponse = yield axios.post("/customers", customerRequest);
      const myUser = { ...userResponse.data };

      // if (imageFile) {
      //   const file = new FormData();
      //   file.append("files", imageFile);
      //   file.append("refId", userResponse.data._id);
      //   file.append("ref", "users");
      //   file.append("field", "photo");

      //   const fileResponse = yield axios.post("/upload?files", file, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   });
      //   myUser.photo = fileResponse.data[0];
      // }
      myUser.phonenumber = formatPhone(myUser.phonenumber);
      // yield put(toggleUserModal(false));
      // yield put(updateUserList(myUser));
      yield put(submitNewUserAdminResponse(myUser));
    } else if (editUserState) {
      const { formValues, imageFile } = payload;
      const { firstname, lastname, phonenumber, email, checkEmail } = formValues;

      const userRequest = {
        firstname,
        lastname,
        phonenumber: phonenumber=='' || phonenumber == null ? "" : '+'+phonenumber.replace(/[^\d]/g, ''),
        role: "5bce0f4b7e768500167699c4",
      };

      if (email !== checkEmail) {
        userRequest.email = email;
        userRequest.username = email;
      }

      const userResponse = yield axios.put(`/users/${formValues._id}`, userRequest);

      // const {
      //   address1,
      //   address2,
      //   city,
      //   stateId: state,
      //   zipcode,
      //   gender,
      //   country,
      //   _id,
      // } = formValues;

      // const { date_of_birth } = payload;
      // const customerRequest = {
      //   date_of_birth,
      //   address1,
      //   address2,
      //   city,
      //   state,
      //   zipcode,
      //   gender,
      //   country,
      //   primary_details: userResponse.data._id,
      // };

      // const customerResponse = yield axios.put(`/customers/${_id}`, customerRequest);
      const myUser = { ...userResponse.data };

      // if (imageFile) {
      //   const file = new FormData();
      //   file.append("files", imageFile);
      //   file.append("refId", userResponse.data._id);
      //   file.append("ref", "users");
      //   file.append("field", "photo");

      //   const fileResponse = yield axios.post("/upload?files", file, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   });
      //   myUser.photo = fileResponse.data === true ? imageFile : fileResponse.data[0];
      // }
      myUser.phonenumber = formatPhone(myUser.phonenumber);
      // yield put(toggleUserModal(false));
      // yield put(updateUserList(myUser));
      yield put(submitEditUserDetailsResponse(myUser));
    }
  } catch (error) {
		console.log("TCL: function*submitNewUser -> error", error)
    // yield put(failResponseMessage(error.response.data.message));
    
    
    yield put(userFailResponse(error.response.data.message));
    // yield put(adminBookFailResponse(error.response.data.message));
  }
}

function* fetchUserDelete({ payload }) {
  try {
    const { allContact } = payload;
		console.log("TCL: function*fetchUserDelete -> allContact", allContact)
    let deleteUserIds = allContact.filter(user => user.selected);
    // const deletedUserPrimaryIds = deleteUserIds.map(
    //   user => user._id
    // );

    deleteUserIds = deleteUserIds.map(user => user._id);

    const myUsersRequestData = deleteUserIds.map(id => axios.delete(`/users/${id}`));
    // const myUsersRequestData = deleteUserIds.map(id => axios.delete(`/customers/${id}`));

    const usersResponse = yield Promise.all(myUsersRequestData);
    // const UsersResposne = yield Promise.all(myUsersRequestData);

    yield put(selectedUserDeleteResposne(deleteUserIds));
  } catch (error) {
    yield put(userFailResponse(error.response.data.message));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(USER_ADMIN_FETCH_ALL_CONTACT, fetchUserRequest),
    takeEvery(SUBMIT_NEW_USER_ADMIN, submitNewUser),
    takeEvery(SELECTED_USER_DELETE, fetchUserDelete),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/UserSaga.js